import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-item-accordion',
  templateUrl: './item-accordion.component.html',
  styleUrls: ['./item-accordion.component.scss']
})
export class ItemAccordionComponent {
  @Input() items: any = [];

  public openedIndex: any = null;

  public toggle(index: number) {
    this.openedIndex = this.openedIndex === index ? null : index;
  }
}
